import { Link } from 'react-router-dom';
import { useConfirmableLinkClick } from '../../lib/useConfirmableLinkClick';

interface DistanceItem {
  label: string;
  value: string;
  link?: string;
  confirm_leave?: 0 | 1 | boolean;
}

function DistanceRow({ item }: { item: DistanceItem }) {
  const onClick = useConfirmableLinkClick(item.link, !!item.confirm_leave);
  const rowContent = (
    <>
      <span className="text-sm text-muted">{item.label}</span>
      <span className="text-sm text-ink font-semibold">{item.value}</span>
    </>
  );
  if (!item.link) {
    return (
      <div className="flex justify-between border-b border-hairline pb-2.5">
        {rowContent}
      </div>
    );
  }
  const isExternal = /^https?:\/\//.test(item.link);
  const linkClasses = 'flex justify-between border-b border-hairline pb-2.5 hover:border-olive transition-colors';
  return isExternal ? (
    <a href={item.link} target="_blank" rel="noopener noreferrer" className={linkClasses} onClick={onClick}>
      {rowContent}
    </a>
  ) : (
    <Link to={item.link} className={linkClasses} onClick={onClick}>
      {rowContent}
    </Link>
  );
}

export default function DistanceList({ items, columns = 4 }: { items: DistanceItem[]; columns?: 2 | 3 | 4 }) {
  const gridCols = { 2: 'sm:grid-cols-2', 3: 'sm:grid-cols-2 lg:grid-cols-3', 4: 'sm:grid-cols-2 lg:grid-cols-4' }[columns];

  return (
    <div className={`grid grid-cols-1 ${gridCols} gap-x-7 gap-y-3.5`}>
      {items.map((item) => (
        <DistanceRow key={item.label} item={item} />
      ))}
    </div>
  );
}
